;(function () {
	var KLAVIYO_BASE = 'https://a.klaviyo.com'
	var DEFAULT_REVISION = '2026-04-15'

	function initForms(root) {
		;(root || document)
			.querySelectorAll('[data-mailing-klaviyo-form]:not([data-mailing-bound])')
			.forEach(function (form) {
				form.dataset.mailingBound = 'true'
				syncReadyState(form)
				bindSmsReveal(form)
				form.addEventListener('submit', handleSubmit)
			})
	}

	function isReady(form) {
		return Boolean(String(form.dataset.companyId || '').trim())
	}

	function syncReadyState(form) {
		var submit = form.querySelector('[type="submit"]')
		var ready = isReady(form)

		form.dataset.klaviyoReady = ready ? 'true' : 'false'

		if (!submit) return

		submit.disabled = !ready
		submit.setAttribute('aria-disabled', ready ? 'false' : 'true')
	}

	function setStatus(form, message, isError) {
		var status = form.querySelector('[data-mailing-status]')
		if (!status) return

		status.textContent = message || ''
		status.classList.toggle('is-visible', Boolean(message))
		status.classList.toggle('is-error', Boolean(message) && Boolean(isError))
		status.setAttribute('role', isError ? 'alert' : 'status')
	}

	// SMS opt-in is US-only: reveal the phone + consent block only when a US state
	// is picked, and clear it otherwise so non-US visitors never submit SMS data.
	function bindSmsReveal(form) {
		var state = form.querySelector('[data-mailing-state]')
		var sms = form.querySelector('[data-mailing-sms]')
		if (!state || !sms) return

		function sync() {
			var eligible = isUsState(state.value)
			sms.hidden = !eligible

			if (!eligible) {
				var phone = sms.querySelector('[data-mailing-phone]')
				var dob = sms.querySelector('[data-mailing-dob]')
				var consent = sms.querySelector('[data-mailing-sms-consent]')
				if (phone) phone.value = ''
				if (dob) dob.value = ''
				if (consent) consent.checked = false
			}
		}

		state.addEventListener('change', sync)
		sync()
	}

	function isUsState(value) {
		var v = String(value || '').trim()
		return Boolean(v) && v !== 'Outside the U.S.'
	}

	// True only when dob is a real YYYY-MM-DD date and the person is >= minAge.
	// Fails closed: a missing, malformed, or impossible date is treated as
	// underage, so SMS is never sent without a verified legal age. Mirrors the
	// approved age gate on the headless storefronts.
	function isOfLegalAge(dob, minAge) {
		var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dob || '').trim())
		if (!match) return false

		var year = Number(match[1])
		var month = Number(match[2])
		var day = Number(match[3])

		// Reject impossible dates (e.g. 2000-02-30) that pass the regex: build the
		// date in UTC and round-trip the components back out.
		var parsed = new Date(Date.UTC(year, month - 1, day))
		if (
			parsed.getUTCFullYear() !== year ||
			parsed.getUTCMonth() + 1 !== month ||
			parsed.getUTCDate() !== day
		) {
			return false
		}

		var now = new Date()
		var age = now.getFullYear() - year
		var monthDiff = now.getMonth() + 1 - month
		if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < day)) age -= 1

		return age >= minAge
	}

	// Best-effort E.164 for US numbers. Returns '' when the input can't be a valid
	// US mobile, so the caller can skip the SMS subscribe rather than send junk.
	function normalizeUsPhone(raw) {
		var value = String(raw || '').trim()
		if (!value) return ''

		var digits = value.replace(/\D/g, '')

		if (digits.length === 10) return '+1' + digits
		if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits
		if (value.charAt(0) === '+' && digits.length >= 11) return '+' + digits

		return ''
	}

	function klaviyoHeaders(revision) {
		return {
			accept: 'application/vnd.api+json',
			'content-type': 'application/vnd.api+json',
			revision: revision || DEFAULT_REVISION,
		}
	}

	function getKlaviyoError(body) {
		if (body && Array.isArray(body.errors) && body.errors[0]) {
			return body.errors[0].detail || body.errors[0].title
		}

		return ''
	}

	// Identify/create the profile with email, state (location.region) and the
	// signup metadata. Runs first so the lead is captured even if a list
	// subscription later fails.
	function createProfile(companyId, revision, attributes) {
		return fetch(KLAVIYO_BASE + '/client/profiles?company_id=' + encodeURIComponent(companyId), {
			method: 'POST',
			headers: klaviyoHeaders(revision),
			body: JSON.stringify({ data: { type: 'profile', attributes: attributes } }),
		})
	}

	function subscribe(companyId, revision, listId, profileAttributes, channel, customSource) {
		var subscriptions = {}
		if (channel === 'email') subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } }
		if (channel === 'sms') subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } }

		var attrs = {}
		Object.keys(profileAttributes).forEach(function (key) {
			attrs[key] = profileAttributes[key]
		})
		attrs.subscriptions = subscriptions

		var payload = {
			data: {
				type: 'subscription',
				attributes: {
					custom_source: customSource || 'Mailing list signup',
					profile: { data: { type: 'profile', attributes: attrs } },
				},
				relationships: { list: { data: { type: 'list', id: listId } } },
			},
		}

		return fetch(KLAVIYO_BASE + '/client/subscriptions?company_id=' + encodeURIComponent(companyId), {
			method: 'POST',
			headers: klaviyoHeaders(revision),
			body: JSON.stringify(payload),
		})
	}

	function collectBrands(form) {
		var checked = form.querySelectorAll('input[name="brands"]:checked')

		return Array.prototype.map.call(checked, function (input) {
			return {
				label: input.dataset.brandLabel || input.value || '',
				emailListId: String(input.dataset.emailListId || '').trim(),
				smsListId: String(input.dataset.smsListId || '').trim(),
			}
		})
	}

	async function handleSubmit(event) {
		event.preventDefault()

		var form = event.currentTarget
		var companyId = String(form.dataset.companyId || '').trim()
		var revision = form.dataset.revision || DEFAULT_REVISION
		var source = form.dataset.source || 'Mailing list signup'
		var minAge = parseInt(form.dataset.minAge, 10) || 21
		var requireBrand = form.dataset.requireBrand !== 'false'
		var successMessage = form.dataset.successMessage || 'Thank you for signing up.'
		var errorMessage = form.dataset.errorMessage || 'Something went wrong. Please try again.'
		var underageMessage =
			form.dataset.underageMessage || 'You must be at least ' + minAge + ' years old to sign up.'
		var brandRequiredMessage = form.dataset.brandRequiredMessage || 'Please select at least one brand.'
		var submit = form.querySelector('[type="submit"]')

		setStatus(form, '', false)
		syncReadyState(form)

		// Native required-field validation (we set novalidate to control ordering).
		if (!form.checkValidity()) {
			form.reportValidity()
			return
		}

		if (!isReady(form)) {
			setStatus(form, 'Sign-up is not configured. Please contact us directly.', true)
			return
		}

		var data = new FormData(form)
		var email = String(data.get('email') || '').trim()
		var state = String(data.get('state') || '').trim()
		var dob = String(data.get('dob') || '').trim()

		var brands = collectBrands(form)
		if (requireBrand && brands.length === 0) {
			setStatus(form, brandRequiredMessage, true)
			return
		}

		// SMS only for US visitors who opted in. The age gate applies ONLY to SMS —
		// email signup is never age-gated.
		var wantsSms = isUsState(state) && data.get('sms_consent') === 'true'
		var phone = ''

		if (wantsSms) {
			if (!isOfLegalAge(dob, minAge)) {
				setStatus(form, underageMessage, true)
				return
			}

			// Don't silently drop an explicit opt-in on a bad number.
			phone = normalizeUsPhone(data.get('phone'))
			if (!phone) {
				setStatus(form, 'Please enter a valid U.S. mobile number to receive texts.', true)
				return
			}
		}

		var properties = {
			$source: source,
			state: state,
			brand_interests: brands.map(function (b) {
				return b.label
			}),
		}
		// Klaviyo's recognized age-gate property — only when SMS (of-age) is in play.
		if (wantsSms && dob) properties.$age_gated_date_of_birth = dob

		var location = { region: state }
		if (isUsState(state)) location.country = 'United States'

		var baseAttributes = {
			email: email,
			location: location,
			properties: properties,
		}
		// Carry the phone as an identifier on the profile create so the email and
		// SMS subscriptions resolve to ONE profile. Consent is scoped per-channel on
		// each subscription below, so this never grants SMS consent on its own.
		if (wantsSms && phone) baseAttributes.phone_number = phone

		if (submit) submit.disabled = true

		try {
			var profileResponse = await createProfile(companyId, revision, baseAttributes)

			if (!profileResponse.ok) {
				var profileBody = null
				try {
					profileBody = await profileResponse.json()
				} catch (e) {
					profileBody = null
				}
				throw new Error(getKlaviyoError(profileBody) || errorMessage)
			}

			// Each checked brand → its email list. SMS list too when eligible.
			var jobs = []

			brands.forEach(function (brand) {
				if (brand.emailListId) {
					jobs.push(subscribe(companyId, revision, brand.emailListId, { email: email }, 'email', source))
				}

				// Phone-only on the SMS (double opt-in) list — including the email here
				// would add it to that list and fire a confirmation email. The merge
				// is handled by the phone identifier on the profile create above.
				if (phone && brand.smsListId) {
					jobs.push(subscribe(companyId, revision, brand.smsListId, { phone_number: phone }, 'sms', source))
				}
			})

			// Subscriptions are best-effort: the profile is already captured, so a
			// single list hiccup must not present as a failed signup.
			if (jobs.length) await Promise.allSettled(jobs)

			form.reset()
			var smsBlock = form.querySelector('[data-mailing-sms]')
			if (smsBlock) smsBlock.hidden = true
			setStatus(form, successMessage, false)
		} catch (error) {
			setStatus(form, error && error.message ? error.message : errorMessage, true)
		} finally {
			if (submit) submit.disabled = !isReady(form)
		}
	}

	function safeInit(root) {
		try {
			initForms(root)
		} catch (e) {
			/* never block the page on a form-init error */
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			safeInit(document)
		})
	} else {
		safeInit(document)
	}

	if (window.Shopify && window.Shopify.designMode) {
		document.addEventListener('shopify:section:load', function (event) {
			safeInit(event.target)
		})
	}
})()
